if (!customElements.get('marquee-text')) {
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('div');
      this.containerLeft = this.parentNode.getBoundingClientRect().left;
      this.currentLeft = 0;
      this.stopped = false;
      this.offsetMargin = 0;
      this.speed = Number(this.getAttribute('data-speed')) || 1;
      this.enablePause = this.getAttribute('data-pause') == 'true' ? true : false;
    }

    animationLoop() {
      if (this.enablePause && this.stopped) return window.requestAnimationFrame(() => { this.animationLoop(); });

      const firstListItem = this.querySelector('div:first-child');
      let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;

      if (rightSideOfFirstItem <= this.containerLeft - this.offsetMargin) {
        this.currentLeft = -1;
        this.appendChild(firstListItem);
      }

      this.style.marginLeft = `${this.currentLeft}px`;
      this.currentLeft -= this.speed;

      window.requestAnimationFrame(() => { this.animationLoop(); });
    }

    connectedCallback() {
      if (!this.hasAttribute('data-enabled')) return;

      this.addEventListener('mouseenter', () => this.stopped = true);
      this.addEventListener('mouseleave', () => this.stopped = false);

      this.animationLoop();
    }
  }

  customElements.define('marquee-text', MarqueeText);
}
